import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiGetOneDocument } from '../../../../actions/DocumentActions';
import { wrapDispatch } from '../../../../helpers/action';
import { propId } from '../../../../helpers/custom-prop-types';
import LockIcon from '../../../Icon/Svg/LockIcon';
import Image from '../../../Ui/Common/Image';
const ColumnContentDocumentOne = (props) => {
    const { id } = props;
    const dispatch = useDispatch();
    const document = useSelector((state) => state.document.one[id]);
    useEffect(() => {
        if (document) {
            return;
        }
        const action = apiGetOneDocument(id);
        wrapDispatch(dispatch, action).then();
    }, [dispatch, document, id]);
    if (!document) {
        return null;
    }
    const { id: documentId, isLimit, thumbnail, title, weightLevel } = document;
    return (_jsx(Link, Object.assign({ to: `/document/${weightLevel}/${documentId}` }, { children: _jsxs("div", Object.assign({ className: 'document_row' }, { children: [_jsx("div", Object.assign({ className: 'document_row_thumbnail_box' }, { children: _jsx(Image, { alt: '', isObjectFit: true, src: thumbnail, useImage: true }) })), _jsxs("div", Object.assign({ className: 'document_row_description_box' }, { children: [_jsx("p", Object.assign({ className: 'title' }, { children: title })), _jsx("ul", Object.assign({ className: 'tag_list' }, { children: _jsx("li", Object.assign({ className: 'tag_row' }, { children: _jsx("span", { children: "\u304A\u5F79\u7ACB\u3061\u8CC7\u6599" }) })) })), isLimit && _jsx(LockIcon, {})] }))] })) })));
};
ColumnContentDocumentOne.propTypes = {
    id: propId().isRequired,
};
export default ColumnContentDocumentOne;
